export enum EmailTemplates {
  gdprMailingList = 125,
  PropertyFeedback = 315,
}
